export const authInputClass =
  'h-[50px] px-4 rounded-semantic bg-semantic-bg-surface border border-semantic-border-2 text-semantic-text-primary text-[15px] outline-none transition-[border-color,box-shadow] focus:border-semantic-emerald focus:!shadow-[0_0_0_3px_var(--color-ring)] placeholder:text-semantic-text-tertiary';
export const authInputWithToggleClass =
  'h-[50px] pl-4 pr-16 rounded-semantic bg-semantic-bg-surface border border-semantic-border-2 text-semantic-text-primary text-[15px] outline-none transition-[border-color,box-shadow] focus:border-semantic-emerald focus:!shadow-[0_0_0_3px_var(--color-ring)] placeholder:text-semantic-text-tertiary';
export const primaryAuthButtonClass =
  'w-full h-[52px] rounded-semantic bg-semantic-emerald text-semantic-emerald-fg font-bold text-[15.5px] transition-colors hover:bg-semantic-emerald-hover';
export const authLabelClass =
  'block text-[13px] font-semibold text-semantic-text-secondary mb-[7px]';
export const authHeadingClass =
  'text-[38px] font-extrabold tracking-[-0.03em] leading-[1.05] text-semantic-text-primary text-center';
export const authSubtitleClass =
  'text-[15.5px] text-semantic-text-secondary mt-[10px] mb-[34px] text-center';
export const authLinkClass =
  'text-semantic-emerald hover:text-semantic-emerald-hover underline underline-offset-2';
export const authFooterLinkClass =
  'text-semantic-emerald hover:text-semantic-emerald-hover font-bold';
